import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProductZoom from "../../components/ProductZoom";
import { useLazyPropertyViewQuery } from "../../redux/api/api";
import TopHeader from "../Dashoboard/TopHeader";

const PropertyRequestView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [details, setDetails] = useState({});

  //RTK QUERY
  const [propertyViewApi] = useLazyPropertyViewQuery();

  const getView = () => {
    propertyViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        setDetails(res);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"property-request-view"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <div className="user-detail-table">
            <table className="tabledetails table-borderless user-det w-100 mb-5">
              <thead>
                <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                  BASIC DETAILS
                </th>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: "40%" }}>Property Id</td>
                  <td>:</td>
                  <td>{details?.property?.property_id}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Property Owner Name</td>
                  <td>:</td>
                  <td>{details?.property?.owner?.name}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Hotel Category</td>
                  <td>:</td>
                  <td>{details?.property?.category?.name}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Category Services</td>
                  <td>:</td>

                  <td>
                    {details?.services?.map((item, ind) => {
                      return (
                        <div className="d-flex flex-column mb-3" key={ind}>
                          {item == "room_booking"
                            ? "Room Booking"
                            : item == "get_together"
                            ? "Get Together"
                            : item == "room_sharing"
                            ? "Room Sharing"
                            : item == "day_outing"
                            ? "Team Outing"
                            : item == "just_walking"
                            ? "Just Walking"
                            : ""}
                        </div>
                      );
                    })}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Property Name</td>
                  <td>:</td>
                  <td>{details?.property?.name}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>State</td>
                  <td>:</td>
                  <td>{details?.property?.state?.name}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>City</td>
                  <td>:</td>
                  <td>{details?.property?.city?.name}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Area</td>
                  <td>:</td>
                  <td>{details?.property?.location?.name}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Street</td>
                  <td>:</td>
                  <td>{details?.property?.street}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Appartment</td>
                  <td>:</td>
                  <td>{details?.property?.apartment}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Block</td>
                  <td>:</td>
                  <td>{details?.property?.block}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Door No</td>
                  <td>:</td>
                  <td>{details?.property?.door_no}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Pincode</td>
                  <td>:</td>
                  <td>{details?.property?.pincode}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Landmark</td>
                  <td>:</td>
                  <td>{details?.property?.landmark}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Latitude</td>
                  <td>:</td>
                  <td>{details?.property?.latitude}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Longitude</td>
                  <td>:</td>
                  <td>{details?.property?.longitude}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Pincode</td>
                  <td>:</td>
                  <td>{details?.property?.pincode}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Amenities</td>
                  <td>:</td>
                  <td className="amenity-type">
                    <ul>
                      {details?.property?.amenities?.map((item, ind) => {
                        return (
                          <li key={ind}>
                            <img src={item?.image} />
                            {item?.name}
                          </li>
                        );
                      })}
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Description</td>
                  <td>:</td>
                  <td>{details?.property?.decscription}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Short Notes</td>
                  <td>:</td>
                  <td>{details?.property?.short_notes}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Policy Rules</td>
                  <td>:</td>
                  <td>{details?.property?.policy_rules}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Couple Friendly</td>
                  <td>:</td>
                  <td>{details?.property?.couple_friendly ? "Yes" : "No"}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Get-To-Gether</td>
                  <td>:</td>
                  <td>{details?.property?.family_friendly ? "Yes" : "No"}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 class="content-heading">
            Property{" "}
            <small>
              <code class="text-lowercase">Images</code>
            </small>
          </h2>
          <div className="d-flex gap-3 mb-5">
            <div className="col-md-4 mx-3">
              {details?.property?.images?.map((item, ind) => {
                return (
                  <div key={ind} className={"mt-2"}>
                    <ProductZoom image_url={item?.image} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyRequestView;
